import { combineReducers } from '@reduxjs/toolkit';
import { reducer as allVacationsReducer } from './model/vacations';
import { reducer as selectedVacationReducer } from './model/selectedVacation';
import { reducer as multiSelectReducer } from './model/multiSelect';

export * as VacationsModel from './model';

const vacationsReducer = combineReducers({
  vacations: allVacationsReducer,
  selectedVacation: selectedVacationReducer,
  multiSelect: multiSelectReducer,
});

export default vacationsReducer;
